import {isTouch} from '@gelato/utils/features';

export default function (dom, opts) {
  let options = {
    tabClass: 'products__tabs-input',
    gridClass: 'products__grid',
    gridActiveClass: 'products__grid--active',
    labelClass: 'product__label',
    labelActiveClass: 'product__label--show-title',
    ...opts
  };

  const tabs = Array.from(dom.querySelectorAll(`.${options.tabClass}`));
  const grids = Array.from(dom.querySelectorAll(`.${options.gridClass}`));
  const labels = Array.from(dom.querySelectorAll(`.${options.labelClass}`));
  const emptyItem = document.createElement('div');
  emptyItem.classList.add('product');
  emptyItem.classList.add('product--empty');

  tabs.forEach(tab => {
    tab.addEventListener('change', e => {
      if (tab.checked) {
        const grid = grids.find(grid => grid.dataset.tab === tab.value);
        grids.forEach(grid => grid.classList.remove(options.gridActiveClass));
        grid.classList.add(options.gridActiveClass);
      }
    });
  });

  if (isTouch) {
    labels.forEach(label => {
      label.addEventListener('click', e => {
        if (label.classList.contains(options.labelActiveClass)) {
          label.classList.remove(options.labelActiveClass);
        }
        else {
          labels.forEach(label => label.classList.remove(options.labelActiveClass));
          label.classList.add(options.labelActiveClass);
        }
      });
    });
  }

  function resize() {
    grids.forEach(grid => {
      const gridCols = +getComputedStyle(grid, ':before').getPropertyValue('content').replace(/[^0-9.]/g, "");
      const gridItems = Array.from(grid.querySelectorAll('.product:not(.product--empty)'));
      const emptyItems = Array.from(grid.querySelectorAll('.product--empty'));
      let short = gridItems.length % gridCols;

      if (short) {
        short = gridCols - short;
      }

      // console.log(gridCols, gridItems.length, emptyItems.length, short);

      if (emptyItems.length > short) {
        emptyItems.slice(0, emptyItems.length - short).forEach(item => {
          grid.removeChild(item);
        });
      }
      else if (emptyItems.length < short) {
        for (let i = 0; i < short - emptyItems.length; i++) {
          grid.appendChild(emptyItem.cloneNode());
        }
      }
    });
  }

  window.addEventListener('resize', resize);
  resize();
}
